 
import { createSlice } from '@reduxjs/toolkit';
import {
  QCTaskUploadsListState,
  QCTaskUploadsListFetchAction,
  QCTaskUploadsListFetchSuccessAction,
  QCTaskFetchEDTFAction,
  QCTaskFetchEDTFSuccessAction,
  QCTaskUploadsSendToWorkstationAction,
} from './QCTaskUploadsList.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: QCTaskUploadsListState = {
  loading: false,
  error: undefined,
  data: [],
  // todo: move this to external edtfSlice
  edtf: {
    data: null,
    loading: false,
    error: undefined,
  },
  sendToWorkstationStatus: {},
  uploadLoadingId: null,
};

const { act, actReject, actResolve } =
  makeActionCreator<QCTaskUploadsListState>();

export const QCTaskUploadsListSlice = createSlice({
  name: 'QCTaskUploadsList',
  initialState,
  reducers: {
    fetchQCTaskUploadsList: act<QCTaskUploadsListFetchAction['payload']>(
      () => ({
        loading: true,
        sendToWorkstationStatus: {},
      })
    ),
    fetchQCTaskUploadsListSuccess:
      actResolve<QCTaskUploadsListFetchSuccessAction['payload']>('data'),
    fetchQCTaskUpload: (state, action) => {
      state.uploadLoadingId = action.payload.uploadId;
    },
    fetchQCTaskUploadSuccess: (state, action) => {
      state.uploadLoadingId = null;
      if (state?.data?.length) {
        state.data = state.data.map(item =>
          item.taskUploadId === action.payload.id
            ? { ...action.payload, taskUploadId: action.payload.id }
            : item
        );
      }
      state.sendToWorkstationStatus[action.payload.id] = {
        sent: false,
        loading: false,
      };
    },
    fetchQCTaskUploadError: state => {
      state.uploadLoadingId = null;
    },
    fetchQCTaskUploadsListFailure: actReject(),
    fetchEDTF: act<QCTaskFetchEDTFAction['payload']>((_, { edtf }) => ({
      edtf: {
        ...edtf,
        loading: true,
      },
    })),
    fetchEDTFSuccess: act<QCTaskFetchEDTFSuccessAction['payload']>(data => ({
      edtf: {
        data,
        loading: false,
        error: undefined,
      },
    })),
    fetchEDTFFailure: act((error, { edtf }) => ({
      edtf: {
        ...edtf,
        loading: false,
        error,
      },
    })),
    fetchSendToWorkStation: act<
      QCTaskUploadsSendToWorkstationAction['payload']
    >(({ uploadId }, state) => ({
      sendToWorkstationStatus: {
        ...state.sendToWorkstationStatus,
        [uploadId]: {
          loading: true,
          sent: false,
        },
      },
    })),
    fetchSendToWorkStationSuccess: act<
      QCTaskUploadsSendToWorkstationAction['payload']
    >(({ uploadId }, state) => ({
      sendToWorkstationStatus: {
        ...state.sendToWorkstationStatus,
        [uploadId]: {
          loading: false,
          sent: true,
        },
      },
    })),
    fetchSendToWorkStationFailure: act<
      QCTaskUploadsSendToWorkstationAction['payload']
    >(({ uploadId }, state) => ({
      sendToWorkstationStatus: {
        ...state.sendToWorkstationStatus,
        [uploadId]: {
          loading: false,
          sent: false,
        },
      },
    })),
    clear: state => {
      state.data = [];
      state.edtf = {
        data: null,
        loading: false,
        error: undefined,
      };
    },
  },
});

export const {
  fetchQCTaskUploadsList,
  fetchQCTaskUploadsListSuccess,
  fetchQCTaskUploadsListFailure,
  clear,
  fetchEDTF,
  fetchEDTFSuccess,
  fetchEDTFFailure,
} = QCTaskUploadsListSlice.actions;

export const actions = {
  ...QCTaskUploadsListSlice.actions,
};

export const selectQCTaskUploadsListState = createSelector('QCTaskUploadsList');

export const useQCTaskUploadsListSlice = createSliceHook(
  QCTaskUploadsListSlice.name,
  actions
);
